import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "Service/api/api";
import { IHints } from "Shared/Types/hints";

const getHints = createAsyncThunk(
  "hints/getHints",
  async (params: IHints | null) => {
    try {
      const response = await api.hints.getHints(params);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
);

export { getHints };
